<template>
    <ac-modal :title="'Plan Details - ' +currentPlan.planName" ref="modal" :size-class="'modal-lg'">
        <div class="row">
            <div :class="hasValue(currentPlan.openTemplate) ? 'col-md-12' : 'col-md-12'">
                <template v-if="showPricing">
                    <h4>Prices and Age Ranges</h4>
                    <template v-for="tier in currentPlan.priceTiers">
                        <span><template v-if="tier.futureSettings">Current: </template>{{ tier.price | currency }} Ages {{ tier.minAge }} - {{ tier.maxAge }} ({{tier.relationship}})</span><br>
                        <template v-if="tier.futureSettings">
                            <span class="highlight">Future Edit: {{ tier.futureSettings.price | currency }} Ages {{ tier.futureSettings.minAge }} - {{
                                    tier.futureSettings.maxAge
                                }} ({{tier.relationship}}) Begins On: {{ tier.futureSettings.effectiveDate |shortDate }}</span><br>
                        </template>
                    </template>
                    <template v-for="tier in deletedOnlyPriceTiers">
                        <span class="red-highlight"><template v-if="tier.endDate">Future Deletes: </template>
                            {{ tier.price | currency }} Ages {{ tier.minAge }} - {{ tier.maxAge }} ({{tier.relationship}}) Ends On: {{ tier.endDate |shortDate }}</span><br>
                    </template>
                    <template v-for="tier in futureOnlyPriceTiers">
                        <span class="green-highlight"><template v-if="tier.effectiveDate">Future Prices: </template>
                            {{ tier.price | currency }} Ages {{ tier.minAge }} - {{ tier.maxAge }} ({{tier.relationship}}) Begins On: {{ tier.effectiveDate |shortDate }}</span><br>
                    </template>
                </template>
                <template v-if="hasPendingChange ">
                    <template v-if="currentPlan.otherServices!=futurePlan.otherServices">
                        <h5>
                            <span class="highlight">Updated Services: </span>
                            <p v-html="futurePlan.otherServices"></p>
                        </h5>
                    </template>
                </template>
            </div>
            <div :class="hasPendingChange ? (hasValue(currentPlan.openTemplate) ? 'col-md-6': 'col-md-4'):'col-md-12'">
                <h4>Current Settings</h4>
                <plan-settings :current-plan="currentPlan">

                </plan-settings>
            </div>
            <div v-if="hasPendingChange" :class="hasValue(currentPlan.openTemplate)? 'col-md-6':'col-md-4'" style="border-left: 1px dotted black">
                <h4>Effective {{ futurePlan.effectiveDate | shortDate }}</h4>
                <plan-settings :current-plan="currentPlan" :future-plan="futurePlan">

                </plan-settings>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import {common} from "../../../global/common.js";
    import PlanSettings from "./PlanSettings.vue";
    import {mapGetters} from 'vuex';

    export default {
        name: "UpcomingChangesModal",
        components: {PlanSettings},
        data() {
            return {
                widgetReady: false,
                currentPlan: {},
                futureOnlyPriceTiers: {},
                deletedOnlyPriceTiers: {}
            }
        },
        computed: {
            hasPendingChange() {
                return Boolean(this.futurePlan) && Boolean(this.futurePlan.planId);
            },
            hasCustomContent() {
                return Boolean(this.$scopedSlots.default);
            },
            ...mapGetters({showPricing: 'globalSettings/showPricing'})
        },
        async mounted() {

        },
        methods: {
            async showModal(planId) {
                let [current, future, futureDeletes] = await Promise.all([
                    api.getData('Shared', planId, 'GetCurrentPlanSettingsView'),
                    api.getData('Shared', planId, 'GetFuturePlanSettingsView'),
                    api.getData('Shared', planId, 'GetFuturePriceTierDeletes'),
                ]);

                let data = await api.get('PriceTier', planId, '');

                for(let cur of current.priceTiers){
                    cur.relationship = common.RELATIONSHIP_TYPE[cur.consumerRelationshipId];
                }
                for (let fut of data.futureOnly)
                {
                    fut.relationship = common.RELATIONSHIP_TYPE[fut.consumerRelationshipId];
                }
                for (let futDel of data.deletedOnly)
                {
                    futDel.relationship = common.RELATIONSHIP_TYPE[futDel.consumerRelationshipId];
                }

                this.currentPlan = current;
                this.futurePlan = future;
                this.futureOnlyPriceTiers = data.futureOnly;
                this.deletedOnlyPriceTiers = data.deletedOnly;
                this.$refs.modal.open();
            }
        }
    }
</script>

<style scoped>
    .highlight {
        background-color: #fff3cd;
    }

    .red-highlight {
        background-color: #f8d7da;
    }

    .green-highlight {
        background-color: #d4edda;
    }
</style>